import { Button, Grid, Typography } from "@mui/material";
import { useAppDispatch } from "../../app/hooks";
import { SchoolInfo, schoolSlice } from "../../redux/school/schoolSlice";
import { useNavigate } from "react-router-dom";
import { selectUser } from "../../redux/user/userSlice";
import { useSelector } from "react-redux";
import { schoolInsUpdSlice } from "../../redux/school/schoolInsUpdSlice";
import { checkIsAdmin } from "../../app/permissions";
import { routeSchool, routeSchoolNew } from "../../routes/school";
import { schoolsSlice, selectSchools } from "../../redux/school/schoolsSlice";
import AddIcon from "@mui/icons-material/Add";
import PrizaAvatarGrid from "../../features/base/grid/PrizaAvatarGrid";
import { assertThumbnailUrl } from "../../redux/common";

interface ContentListProps {
}

const SchoolsList = (props: ContentListProps) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const schools = useSelector(selectSchools);

    const selectSchool = (school: SchoolInfo) => () => {
        console.log(school);
        dispatch(schoolSlice.actions.select(school));
        navigate(routeSchool(school.id));
    };

    const handleNewSchool = () => {
        console.log("New School");
        dispatch(schoolInsUpdSlice.actions.clean());
        navigate(routeSchoolNew());
    };

    const user = useSelector(selectUser);
    const admin = checkIsAdmin(user.priza.info);
    const add = (admin)
        ? <Grid size={40}> <Button onClick={handleNewSchool}>Adicionar</Button>  </Grid>
        : <Typography> Por favor, entre em contato com o administrador. </Typography>;

    const mapped = schools.list ? schools.list.map((item) => {
        return {
            image: assertThumbnailUrl(item.url),
            title: item.name,
            subtitle: "Escola",
            click: selectSchool(item),
            // extra: <Button
            //     variant="outlined"
            //     onClick={selectSchool(item)}
            //     sx={{ marginTop: 1 }}
            //     >
            //     Selecionar
            // </Button>
        };
    }) : [];

    const buttons = admin ? [{ label: <AddIcon />, click: handleNewSchool }] : undefined;

    return <PrizaAvatarGrid
        list={mapped}
        size="80px"
        toolbar={{
            label: "Escolas",
            buttons: buttons
        }}
        state={schools.state}
        retry={() => { dispatch(schoolsSlice.actions.clean()); }}
        messages={{
            empty: "Nenhuma escola associada a esta conta.",
            error: "Erro ao carregar escolas."
        }}
    />;

};

export default SchoolsList;